import {useFormatCurrency} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {Price_Reduction} from '../../../../types/Price';
import {PriceBoxProps} from '../PriceBox';
import {LegalInfoButton} from './LegalInfoButton';
import {SalesCell, StruckPrice} from './Shared';

export const PriceReduction: FC<
  {reduction: Price_Reduction; 'data-testid'?: string} & Pick<
    PriceBoxProps,
    'reverseReductions'
  >
> = ({
  reduction,
  reverseReductions,
  'data-testid': dataTestid = 'strikePrice',
}) => {
  const formatCurrency = useFormatCurrency();

  return (
    <StyledSalesCell $reverse={reverseReductions} data-largerfont>
      {reduction.prefix && <StruckPrice>{reduction.prefix}</StruckPrice>}
      <StruckPrice striked data-testid={dataTestid}>
        {formatCurrency(
          reduction.strikePrice.amount,
          reduction.strikePrice.currencyCode,
        )}
      </StruckPrice>
      {reduction.legalInfo && (
        <LegalInfoButton
          title={reduction.legalInfo.title}
          body={reduction.legalInfo.body.text}
        />
      )}
    </StyledSalesCell>
  );
};

const StyledSalesCell = styled(SalesCell)`
  &:first-child {
    margin-right: 0;
  }
`;
